//menu
export const menuUrl = '/app/menu'
export const getMenuTree = (version) => `${menuUrl}/cache?version=${version}`
export const getMenuPage = () => `${menuUrl}`
export const getMenu = (id) => `${menuUrl}/${id}`
export const createMenu = () => `${menuUrl}`
export const updateMenu = (id) => `${menuUrl}/${id}`
export const deleteMenu = (id) => `${menuUrl}/${id}`
